export const Flash = {
  mounted() {
    window.addEventListener("phx:flash", this.flash.bind(this));
  },

  flash(e) {
    e.preventDefault();
    const message = this.el.dataset.flashMessage || "Default Flash Message";
    const type = this.el.dataset.flashType || "info"; // Default to "info"

    // Push event to LiveView server with both type and message
    this.pushEvent("set_flash", { message: message, type: type });
  },

  destroyed() {
    window.removeEventListener("phx:flash", this.flash.bind(this));
  }
};
